import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import { keysToSnake } from '#/api/adapters/wireCase';

/**
 * PATCH `/crm/sales-order/{id}/line/{lineId}`。
 * PREPARING 配置正式寫入：body **僅** `{ updatedAt, invAllocations[] }`。
 */
export async function updateSalesOrderLine(id, lineId, payload) {
  const { data: raw } = await request.patch(
    `/crm/sales-order/${id}/line/${lineId}`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
